function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\xEC\x88\x98\xEB\x8A\xA5\xEC\x84\xA0\xEB\xB0\xB0_BI 2",
  clipPath: "url(#clip0_2235_2831)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M1.06591 10.7114C2.02354 11.7139 3.59086 12.6547 5.63647 12.6547C8.2266 12.6547 9.05389 11.3458 9.05389 10.3024C9.05389 8.66633 7.29105 8.21642 5.37578 7.72561C3.0474 7.153 0.457267 6.53949 0.457267 3.85998C0.457267 1.61043 2.59013 0.0771484 5.44095 0.0771484C7.66106 0.0771484 9.38081 0.772463 10.5991 1.97854L9.51116 3.22652C8.42318 2.10124 6.9 1.59048 5.31061 1.59048C3.56984 1.59048 2.32838 2.47035 2.32838 3.75823C2.32838 5.12791 4.00398 5.53791 5.85407 6.00778C8.2266 6.60134 10.925 7.29665 10.925 10.1597C10.925 12.1439 9.48908 14.168 5.5713 14.168C3.04634 14.168 1.19625 13.2682 0 12.0003L1.06591 10.7114Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M16.1055 0.28125H17.9125V8.58413C17.9125 11.0791 19.3494 12.6543 22.0258 12.6543C24.7021 12.6543 26.1391 11.0791 26.1391 8.58413V0.28125H27.9461V8.60508C27.9461 11.9998 25.9656 14.1676 22.0258 14.1676C18.0859 14.1676 16.1055 11.9799 16.1055 8.62503V0.28125Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M44.0955 13.9212L35.6293 2.91886V13.9212H33.8223V0.28125H35.6724L44.0304 11.0591V0.28125H45.8363V13.9222H44.0955V13.9212Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M51.7129 13.9212V0.28125H58.1766C60.7016 0.28125 62.2468 1.71278 62.2468 3.75782C62.2468 5.47566 61.0285 6.62089 59.7009 6.88724C61.2461 7.1117 62.5307 8.60508 62.5307 10.2411C62.5307 12.4298 60.9854 13.9222 58.3301 13.9222H51.7139L51.7129 13.9212ZM53.5188 6.19093H57.8718C59.5043 6.19093 60.3747 5.25021 60.3747 4.00223C60.3747 2.75426 59.5043 1.79358 57.8718 1.79358H53.5188V6.19093ZM53.5188 12.4079H57.9591C59.6567 12.4079 60.6575 11.508 60.6575 10.0556C60.6575 8.80759 59.7429 7.70326 57.9591 7.70326H53.5188V12.4069V12.4079Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M78.3096 13.9212L77.025 10.8945H69.6688L68.3853 13.9212H66.3828L72.2159 0.28125H74.458L80.3132 13.9222H78.3106L78.3096 13.9212ZM73.3469 1.79458L70.1913 9.38219H76.4816L73.348 1.79458H73.3469Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M84.6875 13.9212V0.28125H94.1987V1.79458H86.4945V6.19193H94.0462V7.70526H86.4945V12.4089H94.1987V13.9222H84.6875V13.9212Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M99.8226 0.349154C100.82 0.349154 101.633 1.11929 101.633 2.06699C101.633 3.01469 100.821 3.78483 99.8226 3.78483C98.824 3.78483 98.0124 3.01469 98.0124 2.06699C98.0124 1.11929 98.824 0.349154 99.8226 0.349154ZM99.8226 0C98.62 0 97.6445 0.925756 97.6445 2.06699C97.6445 3.20822 98.62 4.13398 99.8226 4.13398C101.025 4.13398 102.001 3.20822 102.001 2.06699C102.001 0.925756 101.025 0 99.8226 0Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M100.333 3.17708L99.8201 2.35807H99.4175V3.17708H99.0117V0.983398H100.027C100.484 0.983398 100.783 1.26671 100.783 1.67073C100.783 2.07475 100.513 2.27227 100.235 2.31517L100.8 3.17708H100.332H100.333ZM99.9725 1.32158H99.4175V2.01889H99.9725C100.202 2.01889 100.368 1.88122 100.368 1.66974C100.368 1.45825 100.202 1.32058 99.9725 1.32058V1.32158Z",
  fill: "black"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2235_2831"
}, /*#__PURE__*/React.createElement("rect", {
  width: 102,
  height: 14.1667,
  fill: "white"
})));

function SvgSunbaelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 15,
    viewBox: "0 0 102 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunbaelogo);
export default __webpack_public_path__ + "static/media/sunbaelogo.fcb21a14.svg";
export { ForwardRef as ReactComponent };